import { RequestType } from './loadingSlice';
import { GlobalAppState } from '@state/store';

export const getLoading = (type: RequestType) => (state: GlobalAppState) => state.app.loading[type] || false;
